import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";

 const MadinaDashboard = () => {
  const { t } = useTranslation();
  return (
    <div className="page-title">
      <h1>الصفحة الرئيسية</h1>
      <Container fluid>{t("WELCOME_MADINAH_DASHBOARD")}</Container>
    </div>
  );
};


export default MadinaDashboard;
